import moment from 'moment';
import cookie from 'js-cookie';

moment.locale(cookie.get('locale') || 'nl')

const PlaceHolderContent = () => {
	return [
		{
			date: moment().isoWeekday(1),
			buildings: [
				{
					owner: '',
					maintainer: '',
					code: '',
					name: '',
					address: '',
					zipcode: '',
					city: '',
					client_number: '',
					inspections: [],
					installations: []
				}
			]
		},
		{
			date: moment().isoWeekday(2),
			buildings: [
				{
					owner: '',
					maintainer: '',
					code: '',
					name: '',
					address: '',
					zipcode: '',
					city: '',
					client_number: '',
					inspections: [],
					installations: []
				}
			]
		},
		{
			date: moment().isoWeekday(3),
			buildings: [
				{
					owner: '',
					maintainer: '',
					code: '',
					name: '',
					address: '',
					zipcode: '',
					city: '',
					client_number: '',
					inspections: [],
					installations: []
				}
			]
		},
		{
			date: moment().isoWeekday(4),
			buildings: [
				{
					owner: '',
					maintainer: '',
					code: '',
					name: '',
					address: '',
					zipcode: '',
					city: '',
					client_number: '',
					inspections: [],
					installations: []
				}
			]
		},
		{
			date: moment().isoWeekday(5),
			buildings: [
				{
					owner: '',
					maintainer: '',
					code: '',
					name: '',
					address: '',
					zipcode: '',
					city: '',
					client_number: '',
					inspections: [],
					installations: []
				}
			]
		}
	]
};

export default PlaceHolderContent;
